import { doodBlockConfig, propertyValue } from "./dood-block-config";
import { cartPagePresetBlockBackgroundColorProperty } from "./cart-page-preset-block-background.util";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const CART_ADDITIONAL_INFORMATION_LEGACY_FIELD_ORDER = [
  { type: "heading", value: "Couleurs" },
  "heading_color",
  "text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartAdditionalInformationBlockDescriptor:
    _generatedCartAdditionalInformationBlockDescriptor,
  cartAdditionalInformationBlockBlocDefinition,
  cartAdditionalInformationBlockDashboardLayout,
  cartAdditionalInformationBlockConfig,
  cartAdditionalInformationBlockResolveConfig,
  cartAdditionalInformationBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart - Additional information",
    componentType: "CartAdditionalInformationBlockComponent",
    category: "cart",
    description: "Cart customer comments block.",
    keywords: ["cart", "comments", "information"],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],

    sharedFields: {},
  },

  () => ({
    background_color: cartPagePresetBlockBackgroundColorProperty(),
    heading_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-800" },
      options: {
        label: "pages.blocks.cart-additional-information.heading-color.label",
      },
    }),
    text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-600" },
      options: {
        label: "pages.blocks.cart-additional-information.text-color.label",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-additional-information.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-page.fieldset.appearance.label",
            fields: ["background_color"],
          },
          {
            legend:
              "pages.blocks.cart-additional-information.fieldset.colors.label",
            fields: ["heading_color", "text_color"],
          },
        ],
      },
    ],
  }),
);

export function cartAdditionalInformationBlockDescriptor(): IBlockDescriptor;
export function cartAdditionalInformationBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartAdditionalInformationBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartAdditionalInformationBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedCartAdditionalInformationBlockDescriptor,
    cartAdditionalInformationBlockProperties,
    fieldOrder,
  );
}

export {
  cartAdditionalInformationBlockBlocDefinition,
  cartAdditionalInformationBlockDashboardLayout,
  cartAdditionalInformationBlockConfig,
  cartAdditionalInformationBlockResolveConfig,
  cartAdditionalInformationBlockProperties,
};

export type CartAdditionalInformationBlockConfig =
  typeof cartAdditionalInformationBlockConfig;
